/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backtobusinesslist3Inputs */

const en_backtobusinesslist3 = /** @type {(inputs: Backtobusinesslist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to business list`)
};

const de_backtobusinesslist3 = /** @type {(inputs: Backtobusinesslist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zur Unternehmensliste`)
};

/**
* | output |
* | --- |
* | "Back to business list" |
*
* @param {Backtobusinesslist3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const backtobusinesslist3 = /** @type {((inputs?: Backtobusinesslist3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backtobusinesslist3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backtobusinesslist3(inputs)
	return de_backtobusinesslist3(inputs)
});
export { backtobusinesslist3 as "backToBusinessList" }